export const customStyle = {
	logo: {
		fontFamily: `'Dancing Script', cursive`,
		color: "#6600ff",
		fontWeight: "bold"
	}
};
